module.exports = __webpack_public_path__ + "media/images/googleIcon-e9ee7c87665e7fd00dca12f97cbf0fb4.svg";